import { useQuery } from 'react-query';
import { LiveFeedEventNews } from '../domain';
import { apiHttpService } from './apiHttpService';
import { useEventFeed } from './useEventFeed';

export function useEventNews(eventId?: string | null) {
  const { dataUpdatedAt: eventFeedUpdatedAt } = useEventFeed({ eventId });

  return useQuery<LiveFeedEventNews[]>(
    ['eventNews', eventId, eventFeedUpdatedAt],
    async () => {
      const { data } = await apiHttpService.get<{
        news: LiveFeedEventNews[];
      }>(`/GetEventNews?eventId=${eventId}`);

      return data.news;
    },
    { enabled: Boolean(eventId && eventFeedUpdatedAt) },
  );
}
